<span
  class="ui-badge"
  [class.ui-badge-neutral]="isNeutral()"
  [class.ui-badge-success]="isSuccess()"
  [class.ui-badge-warning]="isWarning()"
  [class.ui-badge-accent]="isAccent()"
  [class.ui-badge-danger]="isDanger()"
>
  <ng-content />
</span>
